import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
import './dropdown.scss';

const { string, boolean } = proptypes;

export const DropdownItem = (props) => {
  const {
    attributeValue,
    swatchGuid,
    hideOverflow
  } = props;

  return (
    <>
      {swatchGuid && (
        <span className="swatch__image">
          <Image
            alt={attributeValue}
            src={swatchGuid}
            title={attributeValue}
            width="30"
            height="30"
          />
        </span>
      )}
      <span className={`${hideOverflow ? 'drop-down__title--hide-overflow' : ''}`}>{attributeValue}</span>
    </>
  );
};

DropdownItem.displayName = 'DropdownItem';

DropdownItem.propTypes = {
  attributeValue: string,
  swatchGuid: string,
  hideOverflow: boolean
};

DropdownItem.defaultProps = {
  attributeValue: null,
  swatchGuid: null,
  hideOverflow: false
};
